import React from 'react';
import { Link } from 'react-router-dom';

function ConfirmationPaiementModal(props) {
	return (
		<div className="container-modal">
			<div className="background-modal"></div>
			<div className="modal-content confirm-paiement-modal">
				<h4 className="modal-bold-title">Merci</h4>
				<p className="modal-light-text">
					Merci d'avoir réglé la commission. Vous retrouverez le détail des
					paiements effectués dans votre historique.
				</p>
				<button
					type="button"
					className="modal-confirm-btn light-bold"
					onClick={() => props.hideModal()}
				>
					Retour à mes commissions à payer
				</button>
				<Link to={'/'} className="modal-underline-btn light-bold">
					Mon Dashboard
				</Link>
			</div>
		</div>
	);
}

export default ConfirmationPaiementModal;
